export enum ProximityTriggerMethod {
  OnEnter = "onEnter",
  OnExit = "onExit",
}
